/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Account_HeadingInputs */

const en_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save your plan and make it yours.`)
};

const de_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichere deinen Plan und mach ihn zu deinem.`)
};

const pt_br2_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salve seu plano e torne-o seu.`)
};

const tr_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planını kaydet ve kendine göre şekillendir.`)
};

const zh_cn2_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存计划，打造属于你的投资方案。`)
};

const zh_hk2_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存計劃，打造屬於你的投資方案。`)
};

const ko_kr2_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜을 저장하고 나만의 것으로 만드세요.`)
};

const ru_ru2_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните план и сделайте его своим.`)
};

const es_419_onboarding_v1_account_heading = /** @type {(inputs: Onboarding_V1_Account_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda tu plan y hazlo tuyo.`)
};

/**
* | output |
* | --- |
* | "Save your plan and make it yours." |
*
* @param {Onboarding_V1_Account_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_account_heading = /** @type {((inputs?: Onboarding_V1_Account_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Account_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_account_heading(inputs)
	if (locale === "de") return de_onboarding_v1_account_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_account_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_account_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_account_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_account_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_account_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_account_heading(inputs)
	return es_419_onboarding_v1_account_heading(inputs)
});